export const actionTypes = {
  VERIFY_TOKEN: 'VERIFY_TOKEN',
  VERIFY_TOKEN_SUCCESS: 'VERIFY_TOKEN_SUCCESS',
  VERIFY_TOKEN_FAILURE: 'VERIFY_TOKEN_FAILURE',
  UPDATE_USER_INFO: 'UPDATE_USER_INFO',
  UPDATE_BONUS_CHARACTERS: 'UPDATE_BONUS_CHARACTERS',
  UPDATE_REFERRER_ID: 'UPDATE_REFERRER_ID',
  UPDATE_REFERRAL_CODE: 'UPDATE_REFERRAL_CODE',
  REGISTER_REFERRAL: 'REGISTER_REFERRAL',
  UPDATE_REFERRAL_STATS: 'UPDATE_REFERRAL_STATS',
  UPDATE_REFERRAL_REVENUE: 'UPDATE_REFERRAL_REVENUE',
};

const verifyToken = (accessToken) => ({
  type: actionTypes.VERIFY_TOKEN,
  accessToken,
});

const verifyTokenSuccess = (accessToken, user) => ({
  type: actionTypes.VERIFY_TOKEN_SUCCESS,
  accessToken,
  user,
});

const updateUserInfo = (user) => ({
  type: actionTypes.UPDATE_USER_INFO,
  user,
});

const verifyTokenFailure = () => ({ type: actionTypes.VERIFY_TOKEN_FAILURE });

const updateBonusCharacters = (bonusCharacters) => ({
  type: actionTypes.UPDATE_BONUS_CHARACTERS,
  bonusCharacters,
});

const updateReferrerId = (referrerId) => ({
  type: actionTypes.UPDATE_REFERRER_ID,
  referrerId,
});

const updateReferralCode = (referralCode) => ({
  type: actionTypes.UPDATE_REFERRAL_CODE,
  referralCode,
});

const registerReferral = ({ systemReferralCode, joinedAt }) => ({
  type: actionTypes.REGISTER_REFERRAL,
  payload: { systemReferralCode, joinedAt },
});

const updateReferralStats = ({
  earnedPoints,
  spentPoints,
  referralSuccessCount,
}) => ({
  type: actionTypes.UPDATE_REFERRAL_STATS,
  payload: {
    earnedPoints,
    spentPoints,
    referralSuccessCount,
  },
});

const updateReferralRevenue = ({
  totalRevenue,
  refereeFirstPaidOrderCount,
}) => ({
  type: actionTypes.UPDATE_REFERRAL_REVENUE,
  payload: { totalRevenue, refereeFirstPaidOrderCount },
});

export {
  verifyToken,
  verifyTokenSuccess,
  verifyTokenFailure,
  updateUserInfo,
  updateBonusCharacters,
  updateReferrerId,
  updateReferralCode,
  registerReferral,
  updateReferralStats,
  updateReferralRevenue,
};
